import { useEffect } from 'react';
import { onSnakeDied } from '../net/liveSession';
import { getLocalSessionId } from '../net/serverWorld';
import { buzz, HAPTIC } from '../util/haptics';

/**
 * HapticsHub — invisible component that translates server events into
 * device vibrations on mobile. Kept separate from the visual toast
 * components so haptics don't get accidentally suppressed when a
 * toast is hidden / unmounted.
 *
 * Pulses:
 *   - victim == localPlayer → death vibrate ([60, 40, 80] pattern)
 *   - killer == localPlayer → kill vibrate (30 ms)
 *   - neither               → no pulse
 *
 * Milestone pulses live in MilestoneToast (private event already
 * keyed to the local player).
 *
 * The component mounts inside <HUD/>. It renders nothing — just the
 * useEffect subscription.
 */
export function HapticsHub(): null {
  useEffect(() => {
    const off = onSnakeDied((e) => {
      const me = getLocalSessionId();
      if (!me) return;
      if (e.id === me) {
        buzz(HAPTIC.death);
      } else if (e.by === me) {
        buzz(HAPTIC.kill);
      }
    });
    return off;
  }, []);
  return null;
}
